var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "alert-info",
      class: _setup.colors.background,
      attrs: { "data-qa": "alert-info-banner" },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("span", {
        staticClass: "alert-info__icon ui-icon-circle-info",
        class: _setup.colors.icon,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }